import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { Unavailability } from '@repo/domain';
import { useUnavailabilities } from '@repo/domain-service';

const UnavailabilitiesContext = createContext<Unavailability[] | undefined>(undefined);

interface Props {
  parkingId: string;
  children: ReactNode;
}

export function UnavailabilitiesProvider({ parkingId, children }: Props) {
  const { unavailabilities, loadingUnavailabilities } = useUnavailabilities({ parkingId });

  if (loadingUnavailabilities) {
    return null;
  }

  return <UnavailabilitiesContext value={unavailabilities}>{children}</UnavailabilitiesContext>;
}

export function useUnavailabilitiesContext(): Unavailability[] {
  const context = useContext(UnavailabilitiesContext);
  if (context === undefined) {
    throw new Error('useUnavailabilitiesContext must be used within UnavailabilitiesProvider');
  }
  return context;
}
